module.exports = __webpack_public_path__ + "static/media/YF84_1.ce769e46.jpg";